import React, { FC } from 'react'

export const FavouriteActiveSvg: FC<{
  size?: number
  id?: number | string
}> = ({ size = 40, id = 0 }) => (
  <svg width={size} height={size} viewBox="0 0 40 40">
    <defs>
      <linearGradient
        id={`sn0u9vmnca_${id}`}
        x1="50%"
        x2="50%"
        y1="-5.28%"
        y2="118.765%"
      >
        <stop offset="0%" stopColor="#FED576" />
        <stop offset="100%" stopColor="#FFB55A" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <g fill={`url(#sn0u9vmnca_${id})`} transform="translate(-785 -1128)">
        <g>
          <path
            d="M19.37 31.36l-8.1 4.353c-.649.349-1.456.106-1.805-.542-.14-.26-.189-.56-.14-.852l1.561-9.304c.072-.425-.068-.86-.373-1.164l-6.635-6.61c-.52-.52-.522-1.363-.003-1.884.202-.203.465-.336.748-.378l9.117-1.354c.437-.065.812-.341 1.004-.739L18.8 4.485c.32-.663 1.117-.94 1.78-.62.27.13.489.349.62.62l4.056 8.401c.192.398.567.674 1.004.739l9.117 1.354c.728.108 1.23.786 1.122 1.514-.042.283-.174.545-.377.748l-6.635 6.61c-.305.305-.445.739-.373 1.164l1.56 9.304c.123.726-.367 1.413-1.092 1.535-.292.049-.591 0-.852-.14l-8.1-4.354c-.393-.211-.867-.211-1.26 0z"
            transform="translate(785 1128)"
          />
        </g>
      </g>
    </g>
  </svg>
)
